import React from 'react';
import extra1 from '../../../assets/Extra/extra1.jpg';

const Special2 = () => {
    return (
        <div style={{ backgroundColor: 'black' }} className=' text-center my-24'>
            <div  className="container mx-auto flex  justify-center">
            <img className='w-full' src={extra1} alt="" />
            </div>
        </div>
    );
};

export default Special2;